import {
  FeatureAlert,
  useUltimateAlerts,
} from "../../../context/ultimateAlertsContext"
import useStrings from "../../../localization/useStrings"
import svg from "../../../utils/svg"
import styles from "./UltimatePromoFeatureList.module.scss"

interface Feature {
  title: string
  description: string
  inconSvg: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  alert?: FeatureAlert
}

const UltimatePromoFeatureList = () => {
  const strings = useStrings()

  const features: Feature[] = [
    {
      title: strings.premiumToUltimateBlackFriday.cloud.title,
      description: strings.premiumToUltimateBlackFriday.cloud.description,
      inconSvg: svg.featureIcons.CloudVault,
    },
    {
      title: strings.features.duplicateDetection,
      description:
        strings.premiumToUltimateBlackFriday.duplicateDetection.description,
      inconSvg: svg.featureIcons.DuplicateDetection,
    },
    {
      title: strings.features.organizationPlus,
      description:
        strings.premiumToUltimateBlackFriday.organizationPlus.description,
      inconSvg: svg.featureIcons.OrganizationPlus,
      alert: "organization+",
    },
    {
      title: strings.features.securityPlus,
      description:
        strings.premiumToUltimateBlackFriday.securityPlus.description,
      inconSvg: svg.featureIcons.SecurityPlus,
      alert: "security+",
    },
  ]

  return (
    <div className={styles.container}>
      {features.map((feature, index) => (
        <FeatureListItem key={index} {...feature} />
      ))}
    </div>
  )
}

const FeatureListItem = ({
  title,
  description,
  inconSvg: Icon,
  alert,
}: Feature) => {
  const actions = useUltimateAlerts().actions

  return (
    <div className={styles.itemContainer}>
      <div className={styles.iconContainer}>
        <Icon fill="white" />
      </div>
      <div className={styles.textContainer}>
        <div className={styles.titleContainer}>
          <label className={styles.title}>{title}</label>
          {alert != null && (
            <button className={styles.infoContainer}>
              <svg.Info
                className={styles.info}
                onClick={() => {
                  actions.setShowFeatureAlert(alert)
                }}
              />
            </button>
          )}
        </div>
        <label className={styles.description}>{description}</label>
      </div>
    </div>
  )
}

export default UltimatePromoFeatureList
